import { useState } from 'react';
import api from '../../../../services/api';

const useArticleModalQualitativeAnalysisActions = ({
  applyArticleUpdate,
  localArticle,
  setKpiaModalOpen,
  showSnackbar
}) => {
  const [qualitativeAnalysisRunning, setQualitativeAnalysisRunning] = useState(false);

  const handleRunQualitativeAnalysis = async () => {
    if (!localArticle?._id || qualitativeAnalysisRunning) return;
    setQualitativeAnalysisRunning(true);
    try {
      const response = await api.put(`/articles/${localArticle._id}/kpia`, {});
      const result = response.data;
      if (result.success && result.data) {
        applyArticleUpdate(result.data);
        setKpiaModalOpen(true);
        showSnackbar('Análise Qualitativa concluída com sucesso!');
      } else {
        showSnackbar(result.message || 'Erro ao processar Análise Qualitativa');
      }
    } catch (error) {
      console.error('Erro ao executar Análise Qualitativa:', error);
      showSnackbar(error.response?.data?.message || 'Erro ao processar Análise Qualitativa.');
    } finally {
      setQualitativeAnalysisRunning(false);
    }
  };

  return {
    handleRunQualitativeAnalysis,
    qualitativeAnalysisRunning,
    handleAnalyzeKpia: handleRunQualitativeAnalysis,
    kpiaAnalyzing: qualitativeAnalysisRunning
  };
};

export default useArticleModalQualitativeAnalysisActions;
